import { useMutation } from 'react-query';

import { issueUserAccountShopCouponList } from '../graphqls/coupon-download.2';
import { IssueUserAccountShopCouponListInput } from '../graphqls/coupon-download_types.2';

export const useCouponDownloadMutation = () => {
  return useMutation({
    mutationFn: (input: IssueUserAccountShopCouponListInput) => {
      return issueUserAccountShopCouponList({ input }, { show_alert: false });
    },
  });
};
